import { render } from "./PhoneInput.vue?vue&type=template&id=50b9cc65&ts=true"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
